export const pagesIncidentsEn = {
  detail: {
    breadcrumb: {
      home: 'Home',
      incidents: 'Incidents'
    },
    customers: {
      columns: {
        businessPartner: 'Business Partner',
        code: 'Code',
        status: 'Status',
        tier: 'Tier'
      },
      noResults: 'No impacted customers.'
    },
    customersEdit: {
      addCustomers: '+ Add customers',
      addDialog: {
        addButton: 'Add',
        empty: 'No customers available to add',
        searchPlaceholder: 'Search by partner name or code',
        title: 'Add impacted customers'
      },
      changeButton: 'Change Customers',
      currentCustomers: {
        empty: 'No customers are linked',
        remove: 'Remove'
      },
      done: 'Done',
      pageTitle: 'Edit Impacted Customers',
      stepSelectCustomers: 'Select customers',
      toast: {
        addError: 'Failed to add customers',
        addSuccess: 'Linked {{count}} customer(s) to the incident',
        removeError: 'Failed to remove the customer',
        removeSuccess: 'Removed the customer from the incident'
      }
    },
    header: {
      major: 'Major Incident',
      meta: {
        commander: 'Commander',
        detectedAt: 'Detected At',
        mttr: 'MTTR',
        resolvedAt: 'Resolved At',
        sourceSystem: 'Source',
        triggerProduction: 'Trigger Release',
        unset: 'Not set'
      }
    },
    issues: {
      columns: {
        name: 'Issue Name',
        reportedAt: 'Reported Date',
        severity: 'Severity',
        status: 'Status'
      },
      noResults: 'No related issues.'
    },
    issuesEdit: {
      addDialog: {
        addButton: 'Add',
        empty: 'No issues available to add',
        searchPlaceholder: 'Search by name',
        title: 'Add related issues'
      },
      addIssues: '+ Add issues',
      changeButton: 'Change Issues',
      currentIssues: {
        empty: 'No issues are linked',
        remove: 'Remove'
      },
      done: 'Done',
      pageTitle: 'Edit Related Issues',
      stepSelectIssues: 'Select issues',
      toast: {
        addError: 'Failed to add issues',
        addSuccess: 'Linked {{count}} issue(s) to the incident',
        removeError: 'Failed to remove the issue',
        removeSuccess: 'Removed the issue from the incident'
      }
    },
    overview: {
      fields: {
        acknowledgedAt: 'Acknowledged At',
        category: 'Category',
        closedAt: 'Closed At',
        code: 'Code',
        commander: 'Commander',
        detectedAt: 'Detected At',
        detectionMethod: 'Detection Method',
        detectionSource: 'Detection Source',
        externalId: 'External ID',
        impact: 'Impact',
        internalStatus: 'Status',
        isMajor: 'Major Incident',
        mitigatedAt: 'Mitigated At',
        mitigationAction: 'Mitigation Action',
        mttr: 'MTTR',
        note: 'Note',
        priority: 'Priority',
        remediationAction: 'Remediation Action',
        resolvedAt: 'Resolved At',
        rootCause: 'Root Cause',
        rootCauseCategory: 'Root Cause Category',
        severity: 'Severity',
        signal: 'Signal',
        sourceSystem: 'Source System',
        sourceUrl: 'Source URL',
        summary: 'Details',
        tags: 'Tags',
        title: 'Title',
        urgency: 'Urgency',
        workaround: 'Workaround'
      },
      isMajor: {
        false: 'No',
        true: 'Yes'
      },
      mttr: {
        day: '{{count}}d',
        hour: '{{count}}h',
        minute: '{{count}}m',
        separator: ' '
      },
      nullValue: '-',
      pageTitle: 'Incident Detail',
      sections: {
        basic: 'Basic Information',
        cause: 'Root Cause & Remediation',
        detection: 'Detection',
        note: 'Note',
        severity: 'Severity & Status',
        timeline: 'Timeline'
      },
      topSections: {
        analysis: 'Analysis',
        response: 'Response',
        summary: 'Incident Summary'
      }
    },
    productions: {
      columns: {
        category: 'Category',
        description: 'Description',
        releaseLevel: 'Release Level',
        releaseName: 'Release Name',
        releasedAt: 'Released At',
        status: 'Status'
      },
      noResults: 'No impacted releases.'
    },
    productionsEdit: {
      addDialog: {
        addButton: 'Add',
        empty: 'No releases available to add',
        searchPlaceholder: 'Search by release or product name',
        title: 'Add impacted releases'
      },
      addProductions: '+ Add releases',
      changeButton: 'Change Releases',
      currentProductions: {
        empty: 'No releases are linked',
        remove: 'Remove'
      },
      done: 'Done',
      pageTitle: 'Edit Impacted Releases',
      stepSelectProductions: 'Select releases',
      toast: {
        addError: 'Failed to add releases',
        addSuccess: 'Linked {{count}} release(s) to the incident',
        removeError: 'Failed to remove the release',
        removeSuccess: 'Removed the release from the incident'
      }
    },
    tabs: {
      customers: 'Impacted Customers',
      issues: 'Related Issues',
      overview: 'Details',
      productions: 'Impacted Releases',
      targetNodes: 'Impacted Functions'
    },
    targetNodes: {
      empty: 'No impacted functions are registered.',
      table: {
        headers: {
          kind: 'Type',
          name: 'Name',
          publishStatus: 'Publish Status'
        }
      }
    },
    targetNodesEdit: {
      addDialog: {
        addButton: 'Add',
        empty: 'No functions found',
        searchPlaceholder: 'Search by name',
        title: 'Add impacted functions'
      },
      addTargetNodes: '+ Add impacted functions',
      changeButton: 'Change Impacted Functions',
      current: {
        empty: 'No impacted functions are linked',
        remove: 'Unlink'
      },
      done: 'Done',
      pageTitle: 'Edit Impacted Functions',
      stepSelectTargetNodes: 'Select impacted functions',
      toast: {
        addError: 'Failed to link impacted functions',
        addSuccess: 'Linked {{count}} function(s) to the incident',
        removeError: 'Failed to unlink the impacted function',
        removeSuccess: 'Unlinked the impacted function from the incident'
      }
    }
  },
  list: {
    columns: {
      category: 'Category',
      code: 'Code',
      commander: 'Commander',
      detectedAt: 'Detected At',
      impactedCustomerCount: 'Impacted Customers',
      impactedProductNodeCount: 'Impacted Functions',
      internalStatus: 'Status',
      isMajor: 'Major',
      mttr: 'MTTR',
      priority: 'Priority',
      severity: 'Severity',
      title: 'Title',
      triggerProduction: 'Trigger Release'
    },
    filters: {
      category: 'Category',
      priority: 'Priority',
      severity: 'Severity'
    },
    mttr: {
      day: '{{count}}d',
      hour: '{{count}}h',
      minute: '{{count}}m',
      separator: ' '
    },
    noResults: 'No incidents found.',
    pageTitle: 'Incidents',
    searchPlaceholder: 'Search by code or title...',
    statusTabs: {
      all: 'All',
      canceled: 'Canceled',
      closed: 'Closed',
      open: 'Open',
      resolved: 'Resolved'
    },
    tabLabel: 'Incident List'
  },
  options: {
    category: {
      DATA: 'Data',
      DEGRADATION: 'Degradation',
      EXTERNAL: 'External',
      FAILURE: 'Failure',
      SECURITY: 'Security'
    },
    detectionMethod: {
      AUTO_MONITORING: 'Automated Monitoring',
      CUSTOMER_REPORT: 'Customer Report',
      INTERNAL_DISCOVERY: 'Internal Discovery'
    },
    impact: {
      HIGH: 'High',
      LOW: 'Low',
      MEDIUM: 'Medium'
    },
    internalStatus: {
      CANCELED: 'Canceled',
      CLOSED: 'Closed',
      DETECTED: 'Detected',
      IDENTIFIED: 'Identified',
      INVESTIGATING: 'Investigating',
      MITIGATED: 'Mitigated',
      RESOLVED: 'Resolved',
      TRIAGED: 'Triaged'
    },
    priority: {
      P1: 'P1 (Critical)',
      P2: 'P2 (High)',
      P3: 'P3 (Medium)',
      P4: 'P4 (Low)',
      P5: 'P5 (Planned)'
    },
    productionCategory: {
      OTHER: 'Other',
      PLANNED_REGULAR: 'Planned (Regular)',
      PLANNED_SPOT: 'Planned (Spot)',
      UNPLANNED_HOTFIX: 'Unplanned (Hotfix)'
    },
    productionStatus: {
      APPROVED: 'Approved',
      IN_PROGRESS: 'In Progress',
      PLANNED: 'Planned',
      RELEASED: 'Released'
    },
    releaseLevel: {
      HOTFIX: 'Hotfix',
      MAJOR: 'Major',
      MINOR: 'Minor',
      PATCH: 'Patch',
      REVISION: 'Revision'
    },
    rootCauseCategory: {
      CODE: 'Code',
      CONFIG: 'Configuration',
      DATA: 'Data',
      EXTERNAL_DEPENDENCY: 'External Dependency',
      HUMAN: 'Human',
      INFRASTRUCTURE: 'Infrastructure'
    },
    severity: {
      SEV1: 'SEV1 (Critical)',
      SEV2: 'SEV2 (High)',
      SEV3: 'SEV3 (Medium)',
      SEV4: 'SEV4 (Low)'
    },
    sourceSystem: {
      CUSTOMER_REPORT: 'Customer Report',
      MANUAL: 'Manual',
      MONITORING: 'Monitoring',
      ON_CALL: 'On-call'
    },
    urgency: {
      HIGH: 'High',
      LOW: 'Low',
      MEDIUM: 'Medium'
    }
  },
  title: 'Incidents'
};